"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.map");

var _react = require("react");

var _classnames = _interopRequireDefault(require("classnames"));

var _object = _interopRequireDefault(require("object.omit"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _css = require("rc-util/lib/Dom/css");

var _isDocumentAvailable = _interopRequireDefault(require("../utils/isDocumentAvailable"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function removeUndefined(obj) {
  var omitted = Object.entries(obj).filter(function (_ref) {
    var value = _ref[1];
    return value === undefined;
  }).map(function (_ref2) {
    var key = _ref2[0];
    return key;
  });
  return (0, _object["default"])(obj, omitted);
}

var propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  mountNode: (0, _isDocumentAvailable["default"])() ? _propTypes["default"].instanceOf(window.Element) : _propTypes["default"].object,
  prepend: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  style: _propTypes["default"].object // eslint-disable-line react/forbid-prop-types

};
var defaultProps = {
  className: '',
  mountNode: (0, _isDocumentAvailable["default"])() ? document.querySelector('body') : undefined,
  prepend: false,
  id: undefined,
  style: undefined
};

var GrvPortal = /*#__PURE__*/function (_Component) {
  _inheritsLoose(GrvPortal, _Component);

  function GrvPortal(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.portal = void 0;

    if ((0, _isDocumentAvailable["default"])()) {
      _this.portal = document.createElement('div');
    }

    return _this;
  }

  var _proto = GrvPortal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if ((0, _isDocumentAvailable["default"])()) {
      var prepend = this.props.prepend;

      if (prepend) {
        this.mountNode.prepend(this.portal);
      } else {
        this.mountNode.appendChild(this.portal);
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if ((0, _isDocumentAvailable["default"])()) {
      this.mountNode.removeChild(this.portal);
    }
  };

  _proto.render = function render() {
    if ((0, _isDocumentAvailable["default"])()) {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          mountNode = _this$props.mountNode,
          prepend = _this$props.prepend,
          style = _this$props.style,
          otherProps = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "mountNode", "prepend", "style"]);

      this.portal.className = (0, _classnames["default"])('grv-portal', className);
      (0, _css.set)(this.portal, style);
      Object.assign(this.portal, removeUndefined(otherProps));
      return /*#__PURE__*/_reactDom["default"].createPortal(children, this.portal);
    }

    return null;
  };

  _createClass(GrvPortal, [{
    key: "mountNode",
    get: function get() {
      return this.props.mountNode;
    }
  }]);

  return GrvPortal;
}(_react.Component);

GrvPortal.propTypes = propTypes;
GrvPortal.defaultProps = defaultProps;
var _default = GrvPortal;
exports["default"] = _default;